/*
 * Loads Razorpay's checkout script only when a payment starts (not when a
 * review page opens), so pages don't fetch Razorpay's ~180 kB of extra
 * scripts until the guest actually pays.
 *
 *   await loadRazorpay()  -> resolves with window.Razorpay, rejects if it can't load
 */
const SRC = 'https://checkout.razorpay.com/v1/checkout.js';
const TIMEOUT_MS = 15000;

let loading = null;

export default function loadRazorpay() {
    if (window.Razorpay) return Promise.resolve(window.Razorpay);
    if (loading) return loading;

    loading = new Promise((resolve, reject) => {
        const done = (error) => {
            clearTimeout(timer);
            if (!error && window.Razorpay) return resolve(window.Razorpay);
            loading = null; // let the next click try again
            return reject(error || new Error('Razorpay did not load'));
        };
        const timer = setTimeout(() => done(new Error('Razorpay took too long to load')), TIMEOUT_MS);

        let script = document.querySelector(`script[src="${SRC}"]`);
        if (!script) {
            script = document.createElement('script');
            script.src = SRC;
            script.async = true;
            document.body.appendChild(script);
        }
        script.addEventListener('load', () => done());
        script.addEventListener('error', () => {
            script.remove();
            done(new Error('Razorpay failed to load'));
        });
    });

    return loading;
}
